<template>
  <div id="live_submenu">
    <b-button
      v-for="(parcours, index) in list_parcours"
      :key="index"
      :class="[parcours === current_parcours ? 'active' : '']"
      class="inline-submenu-btn-sm with_icon"
      @click="changeParcours(parcours)"
    >
      <b-icon icon="geo" aria-hidden="true"></b-icon>
      {{ parcours }}</b-button
    >
  </div>
</template>

<script>
export default {
  props: ["list_parcours", "current_parcours"],
  data() {
    return {};
  },

  methods: {
    changeParcours(p) {
      this.$emit("changeParcours", p);
    },
  },
  mounted() {
    if (this.current_parcours === "") {
      this.changeParcours(this.list_parcours[0]);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>